import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { find } from 'lodash';
import ReactGA from 'react-ga';

import arrowLeft from './arrowLeft.svg';
import phoneButton from './phoneButton.svg';
import desktopPhone from './desktopPhone.svg';

class Call extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: '',
    };
  }

  componentWillMount() {
    if (this.props.reps.length === 0) {
      browserHistory.push(`/${this.props.params.appId}`);
      return;
    }

    if (this.props.reps) {
      let rep = find(this.props.reps, (rep) => rep.bioguide_id === this.props.params.id);
      this.setState({
        text: eval('`'+this.props.messages.phone+'`'),
      });
    }
  }

  handleClick = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'make call'
    });
  }

  handleBack = () => {
    ReactGA.event({
      category: 'Bespoke Contact Congress',
      action: 'click',
      label: 'previous'
    });

    browserHistory.goBack();
  }

  render() {
    const rep = find(this.props.reps, (rep) => rep.bioguide_id === this.props.params.id);

    if (!rep) return null;
    return (
      <div className="Call">
        <h2>Call your Legislator</h2>
          <label className="zipLabel" htmlFor="zip">Suggested Script:</label>

          <textarea className="script" value={this.state.text} readOnly></textarea>
          <a className="phoneInfo" onClick={this.handleClick} target="_parent" href={`tel:${rep.phone}`}><img src={desktopPhone} /> {rep.phone}</a>
          <a className="phoneButton" onClick={this.handleClick} target="_parent" href={`tel:${rep.phone}`}><img src={phoneButton} /></a>
          <a className="previousButton" onClick={this.handleBack}><img className="previousArrow" src={arrowLeft} />Previous</a>
      </div>
    );
  }
};

export default Call;




// WEBPACK FOOTER //
// ./src/Call.js